<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import {
  KkIcon
} from '../../../base'
import { KkInfo } from '../../../ui'
import {
  KkAccountContainer
} from '../../../../components/domains/sns'

const store = useStore()
const { t } = useI18n()

const post = computed(() => store.getters['companiesStoreSnsPosts/post'])
const selectedPostSnsType = computed(() => store.getters['companiesStoreSnsPosts/selectedPostSnsType'])
const deselectAccount = (payload) => store.dispatch('companiesStoreSnsPosts/deselectAccount', payload)
const deselectAllAccounts = () => store.dispatch('companiesStoreSnsPosts/deselectAllAccounts')

const isSelectedAccounts = computed(() => post.value.facebookPages.length || post.value.instagramBusinessAccounts.length || post.value.twitterUserProfiles.length)

const selectedAccounts = computed(() => {
  switch(selectedPostSnsType.value) {
  case 'FACEBOOK':
    return post.value.facebookPages
  case 'INSTAGRAM':
    return post.value.instagramBusinessAccounts
  case 'TWITTER':
    return post.value.twitterUserProfiles
  default:
    return post.value.facebookPages.concat(post.value.instagramBusinessAccounts, post.value.twitterUserProfiles)
  }
})

const emit = defineEmits(['open-accounts-modal'])

const openAccountsModal = () => {
  emit('open-accounts-modal')
}
const deselectAll = () => {
  deselectAllAccounts()
}

const deselect = (payload) => {
  deselectAccount(payload)
}
</script>
<template>
  <div>
    <div class="account">
      <div v-if="isSelectedAccounts" class="account__header">
        <div>
          {{ t('pages.CompaniesStoreSnsPost.form.accountTitle') }}：
          <span class="countLabel">{{ t('pages.CompaniesStoreSnsPost.form.accountCount', {count: selectedAccounts.length}) }}</span>
        </div>
        <button class="account__deselect" type="button" @click="deselectAll">
          <KkIcon name="delete" color="rgba(58, 59, 63, 0.7)" class="account__deselect__icon" />
          {{ t('pages.CompaniesStoreSnsPost.form.deselectAll') }}
        </button>
      </div>
      <div v-else class="account__header">
        <div>
          {{ t('pages.CompaniesStoreSnsPost.form.accountTitle') }}：
          <span class="countLabel">{{ t('messages.notSelected') }}</span>
        </div>
      </div>
      <KkAccountContainer
        v-if="isSelectedAccounts"
        :accounts="selectedAccounts"
        :show-deselect="true"
        :is-scrollable="true"
        @deselect="deselect($event)"
      />
      <div class="c-button c-button--icon">
        <button type="button" class="c-button__item" @click="openAccountsModal">
          <KkIcon name="add" color="#E9446A" class="c-button__icon" />
          <span class="selectLabel">{{ t('pages.CompaniesStoreSnsPost.form.selectAccount') }}</span>
        </button>
      </div>
      <KkInfo icon="hint" class="account__info">
        {{ $t('pages.CompaniesStoreSnsPost.form.accountNote') }}
      </KkInfo>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.account {
  .c-button {
    margin: 0;
  }
  .c-button__item {
    margin: 0;
    padding: 0;
  }
  .selectLabel {
    color: #E9446A;
  }
  &__header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    .countLabel {
      font-weight: bold
    }
  }
  &__list {
    margin-bottom: 16px;
  }
  &__info {
    margin-top: 16px;
  }
  &__deselect {
    display: flex;
    align-items: center;
    margin-left: auto;
    &__icon {
      width: 16px;
      margin-right: 5px;
    }
  }
  &__content {
    border: 1px solid #E4E7EB;
    border-radius: 4px;
    margin-bottom: 16px;
    max-height: 340px;
    overflow-y: scroll;
  }
}
</style>
